module.exports = __webpack_public_path__ + "img/trash-can-slash.272850ca.svg";